<template>
  <div>
    <div>
      <el-row :gutter="10">
        <el-col :xs="24" :lg="8" v-if="dataRange === 'month'">
          <span> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            size="mini"
            value-format="yyyy-MM"
            @change="monthChange"
            :picker-options="pickerOptions"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 20px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row>
        <el-col :span="24">
          <el-table
            border
            v-loading="loading"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            :row-class-name="tableRowClassName"
            :data="tableData"
          >
            <el-table-column type="index" label="序号" width="50" fixed>
            </el-table-column>
            <el-table-column prop="name" label="指标" fixed></el-table-column>
            <el-table-column prop="benyue" sortable label="本月">
              <template slot-scope="scope">
                <span>{{ scope.row.benyue.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dyhb" sortable label="当月环比（±）">
              <template slot-scope="scope">
                <span>{{ scope.row.dyhb.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dytb" sortable label="当月同比（±）">
              <template slot-scope="scope">
                <span>{{ scope.row.dytb.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bylj1" sortable label="1-本月累计">
              <template slot-scope="scope">
                <span>{{ scope.row.bylj1.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ljtb" sortable label="累计同比（±）">
              <template slot-scope="scope">
                <span>{{ scope.row.ljtb.toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      areaName: "",
      dialogTableVisible: false,
      loading: false,
      exportLabel: "<<点击此处可导出报表",
      queryData: {},
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currMonth", //时间类型
      dataIndex: "gyzjz", //数据指标
      dataRange: "month", //数据类型
      times: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: [],
        pre: [],
        profit: [],
      },
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.area;
      this.areaCode = row.code;
      console.log("this.areaCode:", this.areaCode);
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      const self = this;
      this.loading = true;
      this.queryData.date = this.times;
      this.queryData.page = 1;
      this.queryData.pageSize = 10;
      this.$axios
        .get("/business/region/queryAntecedent", { params: this.queryData })
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: [],
            pre: [],
            profit: [],
          };
          this.showArea = false;
          this.loading = false;
          if (res.data) {
            this.tableData = res.data;
            setTimeout(function () {
              self.showArea = true;
            }, 5);
          }
        });
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
    },
    monthChange(value) {
      this.initData();
    },
    exportData() {
      let column = [
        {
          title: "指标",
          key: "name",
        },
        {
          title: "本月",
          toFixed: 2,
          key: "benyue",
        },
        {
          title: "当月环比（±）",
          toFixed: 1,
          key: "dyhb",
        },
        {
          title: "当月同比（±）",
          toFixed: 1,
          key: "dytb",
        },
        {
          title: "1-本月累计",
          toFixed: 2,
          key: "bylj1",
        },
        {
          title: "累计同比（±）",
          toFixed: 1,
          key: "ljtb",
        },
      ];
      export2Excel(
        column,
        this.tableData,
        this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月"
      );
    },
  },
  created() {
    this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.initData();
  },
};
</script>